const PREFIX = 'DEFAULT_SETTING_';

export const FETCH_REPORT_DEFAULT_SETTINGS = PREFIX + 'FETCH_REPORT_DEFAULT_SETTINGS';
export const FETCH_FEATURE_REPORTS = PREFIX + 'FETCH_FEATURE_REPORTS';
